import React, {Component} from 'react'
import {Input, Grid} from 'react-spreadsheet-grid'
import {Collapse} from 'react-collapse'
import {Table} from "react-bootstrap"



export class CalculatingElementsTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns_region: [],
            columns: [],
        }
    }

    componentDidMount() {
        this.populateFieldsData();
    }

    static renderTable(columns, rows, field_row, columnsRegion, isActive, handleCheckElement) {
        return (
            rows.length !== 0 ?
                <div>
                    <div className='calc-table-label'>Потребность элементов питания</div>
                    <Collapse isOpened={(field_row.length !== 0) ? field_row[0].expand : false}>
                        <Table className="calc-element-table-head bordered">
                            <thead className="align-middle">
                            <tr>
                                <th style={{width: '34%'}}>Участок</th>
                                <th style={{width: '11%'}}>N<br/>кг/га д.в.</th>
                                <th style={{width: '11%'}}>P₂O₅<br/>кг/га д.в.</th>
                                <th style={{width: '11%'}}>K₂O<br/>кг/га д.в.</th>
                                <th style={{width: '11%'}} className={isActive.s ? "element-cell" : "element-cell disable"}>
                                    S<br/>кг/га д.в.
                                    <label className='element-checkbox'>
                                        <input type="checkbox" checked={isActive.s} onChange={() => handleCheckElement('s')}/>
                                        <span></span>
                                    </label>

                                </th>
                                <th style={{width: '11%'}} className={isActive.caO ? "element-cell" : "element-cell disable"}>
                                    CaO<br/>кг/га д.в.
                                    <label className='element-checkbox'>
                                        <input type="checkbox" checked={isActive.caO} onChange={() => handleCheckElement('caO')}/>
                                        <span></span>
                                    </label>
                                </th>
                                <th style={{width: '11%'}} className={isActive.mg ? "element-cell" : "element-cell disable"}>
                                    Mg<br/>кг/га д.в.
                                    <label className='element-checkbox last-checkbox'>
                                        <input type="checkbox" checked={isActive.mg} onChange={() => handleCheckElement('mg')}/>
                                        <span></span>
                                    </label>
                                </th>
                            </tr>
                            </thead>
                        </Table>
                        <div id="calculating_regions_table">
                            <Grid
                                key={field_row.id}
                                columns={columnsRegion}
                                rows={rows}
                                rowHeight={75}
                                getRowKey={rows => rows.id}
                                isScrollable={false}
                                disabledCellChecker={(row, columnId) => {
                                    return columnId === 'name' ||
                                        columnId === 'N' ||
                                        columnId === 'P2O5' ||
                                        columnId === 'K2O' ||
                                        columnId === 'S' ||
                                        columnId === 'CaO' ||
                                        columnId === 'Mg';
                                }}
                            />
                        </div>
                        <br/>
                        <div id="calculating_field_table">
                            <Grid
                                columns={columns}
                                rows={field_row}
                                rowHeight={75}
                                getRowKey={field_row => field_row.id}
                                disabledCellChecker={(field_row, columnId) => {
                                    return columnId === 'button_expand' ||
                                        columnId === 'N' ||
                                        columnId === 'P2O5' ||
                                        columnId === 'K2O' ||
                                        columnId === 'S' ||
                                        columnId === 'CaO' ||
                                        columnId === 'Mg' ||
                                        columnId === 'empty';
                                }}
                            />
                        </div>
                    </Collapse>
                </div> : <div></div>
        );
    }


    render() {
        return (
            CalculatingElementsTable.renderTable(
                this.state.columns,
                this.props.calculation_data,
                this.props.dose_row,
                this.state.columns_region,
                this.props.isActive,
                this.props.handleCheckElement)
        );
    }

    async populateFieldsData() {
        const numberFormat = new Intl.NumberFormat('ru-RU')

        function formatCell(value) {
            return value ? numberFormat.format(value.toString().replace(',', '.')).replace(',', '.') : 0
        }

        const columns = [
            {
                id: 'empty',
                title: '',
                value: (row, {focus}) => {
                    return (<Input
                        value={"Потребность эл. питания на га в д.в. (средняя): "}
                        focus={focus}
                    />);
                },
                width: 34,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.n)}
                            focus={focus}
                        />
                    );
                },
                id: 'N',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.p2O5)}
                            focus={focus}
                        />
                    );
                },
                id: 'P2O5',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.k2O)}
                            focus={focus}
                        />
                    );
                },
                id: 'K2O',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.props.isActive.s ? "" : "disable"}>
                            <Input
                                value={formatCell(row.element.s)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'S',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.props.isActive.caO ? "" : "disable"}>
                            <Input
                                value={formatCell(row.element.caO)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'CaO',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.props.isActive.mg ? "" : "disable"}>
                            <Input
                                value={formatCell(row.element.mg)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'Mg',
                width: 11,
            }
        ];

        const columns_region = [
            {
                title: "",
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={row.name}
                            focus={focus}
                        />
                    );
                },
                className: "name",
                id: 'name',
                width: 34
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.n)}
                            focus={focus}
                        />
                    );
                },
                id: 'N',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.p2O5)}
                            focus={focus}
                        />
                    );
                },
                id: 'P2O5',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Input
                            value={formatCell(row.element.k2O)}
                            focus={focus}
                        />
                    );
                },
                id: 'K2O',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.props.isActive.s ? "" : "disable"}>
                            <Input
                                value={formatCell(row.element.s)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'S',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.props.isActive.caO ? "" : "disable"}>
                            <Input
                                value={formatCell(row.element.caO)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'CaO',
                width: 11,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <div className={this.props.isActive.mg ? "" : "disable"}>
                            <Input
                                value={formatCell(row.element.mg)}
                                focus={focus}
                            />
                        </div>
                    );
                },
                id: 'Mg',
                width: 11,
            }
        ];

        this.setState({
            columns: columns,
            columns_region: columns_region,
        });
    }

}
